import { render, staticRenderFns } from "./container.vue?vue&type=template&id=58f85767&"
import script from "./container.ts?vue&type=script&lang=ts&"
export * from "./container.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports